/**
 * Navigate to a page and scroll to a specific section by ID.
 * Retries up to 20 times (2 seconds total) to handle async renders.
 */
export function scrollToSection(sectionId: string, offset = 80): void {
  let attempts = 0;
  const maxAttempts = 20;

  const tryScroll = () => {
    const el = document.getElementById(sectionId);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    } else if (attempts < maxAttempts) {
      attempts += 1;
      setTimeout(tryScroll, 100);
    }
  };

  // Small initial delay to let React render the new page
  setTimeout(tryScroll, 80);
}
